window.addEventListener('DOMContentLoaded', () => {
  const members = document.querySelectorAll('.member')

  if ( members ) {
    members.forEach(member => 
      member.addEventListener('click', () => 
        member.dataset.clicked === '0' 
          ? member.dataset.clicked = '1'
          : member.dataset.clicked = '0')
    )
  }
})